import { createBrowserRouter } from "react-router-dom";
import RootLayout from "../components/RootLayout";
import { ErrorPage } from "./ErrorPage";
import Home from "../Pages/Home/Home";
import Jobs from "../Pages/jobs/Jobs";
import Connect from "../Pages/Connect/Connect";
import UsersControl from "../Dashboard/UsersControl/UsersControl";
import Categories from "../Dashboard/Categories/Categories";
import ArticlesControl from "../Dashboard/ArticlesControl/ArticlesControl";
import AddSlider from "../Dashboard/TitlesSlider/AddSlider";
import Login from "../Pages/Login/Login";
import Dashboard from "../Dashboard";
import PhotoSliders from "../Dashboard/SliderPhotos/PhotoSliders";
import NewsControl from "../Dashboard/NewsControl/NewsControl";
import JobsControl from "../Dashboard/JobsControl/JobsControl";
import JobRequestsControl from "../Dashboard/JobRequestsControl/JobRequestsControl";
import Products from "../Pages/Products/Products";
import ArticleDetails from "../Pages/ArticleDetails/ArticleDetails";
import NewsDetails from "../Pages/NewsDetails/NewsDetails";
import AboutControl from "../Dashboard/AboutControl/AboutControl";
import Articles from "../Sections/Articles/Articles";
import Banners from "../Dashboard/BannersControls/Banner";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Home /> },
      { path: "Jobs", element: <Jobs /> },
      { path: "Connect", element: <Connect /> },
      { path: "Articles/:articleId", element: <ArticleDetails /> },
      { path: "News/:newsId", element: <NewsDetails /> },
      { path: "Products", element: <Products /> },
      { path: "Articles", element: <Articles /> },
    ],
  },
  {
    path: "dashboard",
    element: <Dashboard />,
    // loader: (e) => {
    //   if (store.getState().auth.userData?.role !== "admin") {
    //     window.location.href = "/";
    //   }
    //   return null;
    // },
    children: [
      { index: true, element: <UsersControl /> },
      { path: "users", element: <UsersControl /> },
      { path: "category", element: <Categories /> },
      { path: "PhotoSliders", element: <PhotoSliders /> },
      { path: "banners", element: <Banners /> },
      { path: "articles", element: <ArticlesControl /> },
      { path: "news", element: <NewsControl /> },
      { path: "AddSlider", element: <AddSlider /> },
      { path: "jobs", element: <JobsControl /> },
      { path: "jobRequests", element: <JobRequestsControl /> },
      { path: "about", element: <AboutControl /> },
    ],
  },
  {
    path: "login",
    element: <Login />,
  },
]);
